module.exports = __webpack_public_path__ + "img/relevance.1c96a471.svg";